import { useDefaultDataLayer } from '../useDataLayer';

/**
 * Hook for tracking SPA page view events
 * @param {Object} options - Configuration options
 * @returns {Object} - Tracking method
 */
export function useSpaPageViewTracking(options = {}) {
  const { registerPageView } = useDefaultDataLayer();

  /**
   * Track a SPA page view event
   * @param {Object} additionalData - Any additional data to include
   */
  const trackSpaPageView = (additionalData = {}) => {
    registerPageView({
      ...options,
      ...additionalData,
    });
  };

  return {
    trackSpaPageView,
  };
}
